import React from 'react';
import { LazySection } from './LazySection';
export function Bonos() {
  return <LazySection className="bg-cream-dark !py-[80px] md:!py-[100px]" data-id="element-54">
      <div className="container-wide" data-id="element-55">
        <div className="text-center mb-[50px]" data-id="element-56">
          <h2 className="text-[clamp(32px,4.8vw,48px)] mb-3" data-id="element-57">
            🎁 4 Bonos Estratégicos
          </h2>
          <p className="text-gold-dark text-[14px] tracking-[0.2em] uppercase font-semibold" data-id="element-58">
            Solo en el Sistema Completo · Sin costo adicional
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5 max-w-[900px] mx-auto mb-[40px]" data-id="element-59">
          {[{
          num: '01',
          tag: '🌸 BONO 1',
          title: 'Protocolo de Linaje Materno',
          desc: 'Proceso guiado específico para trabajar la herida materna — la lealtad más profunda del sistema familiar femenino.',
          oldPrice: '$12.000'
        }, {
          num: '02',
          tag: '🌿 BONO 2',
          title: 'Protocolo de Linaje Paterno',
          desc: 'Proceso guiado para integrar la herida paterna — la llave del mandato del merecimiento: recibir amor, dinero y reconocimiento sin culpa.',
          oldPrice: '$12.000'
        }, {
          num: '03',
          tag: '🧸 BONO 3',
          title: 'Protocolo de la Voz Crítica · Origen Pre-Verbal',
          desc: 'El proceso más profundo del sistema. Identificás y reescribís los mensajes que recibiste antes de poder elegir — la raíz de esa voz que no para.',
          oldPrice: '$10.000'
        }, {
          num: '04',
          tag: '📓 BONO 4',
          title: 'Diario Guiado de 12 Meses',
          desc: 'Tu compañero diario durante todo el proceso. Un prompt cada día para que el cambio se sostenga en el tiempo.',
          oldPrice: '$8.000'
        }].map((bono, i) => <div key={i} className="bg-white border border-border rounded-[16px] p-7 relative transition-all duration-300 hover:-translate-y-1 hover:shadow-soft hover:border-gold flex flex-col" data-id="element-60">
              <div className="font-serif text-[32px] text-gold font-medium leading-none mb-1" data-id="element-61">
                {bono.num}
              </div>
              <div className="inline-block bg-gold/10 text-gold-dark text-[11px] font-semibold px-2.5 py-1 rounded-full tracking-[0.1em] mb-3.5 w-fit" data-id="element-62">
                {bono.tag}
              </div>
              <h3 className="text-[18px] mb-2.5 leading-[1.3]" data-id="element-63">{bono.title}</h3>
              <p className="text-[14px] text-ink-soft leading-[1.55] mb-4 flex-grow" data-id="element-64">
                {bono.desc.includes('lealtad') ? <>
                    Proceso guiado específico para trabajar la herida materna —
                    la <span className="highlight-keyword" data-id="element-65">lealtad</span> más
                    profunda del sistema familiar femenino.
                  </> : bono.desc}
              </p>
              <div className="flex items-center gap-2.5 text-[13px] mt-auto" data-id="element-66">
                <span className="text-ink-soft line-through opacity-60" data-id="element-67">
                  {bono.oldPrice}
                </span>
                <span className="bg-ink text-gold-light px-3 py-1 rounded-full font-semibold tracking-[0.08em] text-[11px]" data-id="element-68">
                  GRATIS
                </span>
              </div>
            </div>)}
        </div>

        <div className="text-center max-w-[720px] mx-auto bg-ink text-cream px-8 py-6 rounded-[16px]" data-id="element-69">
          <div className="text-[12px] tracking-[0.2em] uppercase text-cream/60 mb-1.5" data-id="element-70">
            Valor total de los bonos
          </div>
          <div className="font-serif text-[22px] text-gold-light" data-id="element-71">
            <span className="text-cream/40 line-through mr-2.5" data-id="element-72">$42.000</span>
            GRATIS con el Sistema Completo
          </div>
        </div>
      </div>
    </LazySection>;
}